import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Stable id for optimistic rows, so React keys don't thrash on reconcile. */
export function tempId(prefix = 'tmp') {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}

export function isTempId(id: string) {
  return id.startsWith('tmp_') || id.includes('_tmp_');
}

export function sleep(ms: number) {
  return new Promise((r) => setTimeout(r, ms));
}
